export const MenuList = [
    {
        title: 'Tasks',
        menu_key: 'tasks',
        classsChange: 'mm-collapse',
        iconStyle: <i className="fas fa-tasks"></i>,
        content: [
            {
                title: 'Dashboard',
                menu_key: 'task_list',
                to: '/task/tasklist'
            },
            {
                title: 'Performance Report',
                menu_key: 'performance',
                to: '/task/performance',
                section: 'performance',
                requiredAction: 'view',
            },
            {
                title: 'Worksheet',
                menu_key: 'worksheet',
                to: '/task/worksheet',
                feature_key: 'worksheet',
                section: 'worksheet',
                requiredAction: 'view',
            },
            {
                title: 'Work Register',
                menu_key: 'work_register',
                to: '/work-register/list',
                section: 'work_register',
                requiredAction: 'view',
            },
            {
                title: 'Team Work Register',
                menu_key: 'work_register_team',
                to: '/work-register/team',
                section: 'work_register_team',
                requiredAction: 'view',
            },
        ],
    },
    {
        title: 'Projects',
        menu_key: 'projects',
        classsChange: 'mm-collapse',
        iconStyle: <i className="fas fa-briefcase"></i>,
        /** Access is gated by the Task plan `project` feature — not a separate subscription. */
        content: [
            {
                title: 'Dashboard',
                menu_key: 'project',
                to: '/task/projectdashboard',
                feature_key: 'project',
            },
            {
                title: 'Project List',
                menu_key: 'project',
                to: '/task/projectlist',
                feature_key: 'project',
            },
            {
                title: 'Project Tasks',
                menu_key: 'project',
                to: '/task/projecttasklist',
                feature_key: 'project',
            },
            {
                title: 'Create New Project',
                menu_key: 'project',
                to: '/task/addproject',
                feature_key: 'project',
                section: 'projects',
                requiredAction: 'create_edit',
            },
        ],
    },
    {
        title: 'Discussion Forum',
        menu_key: 'forum',
        classsChange: 'mm-collapse',
        iconStyle: <i className="fas fa-comments"></i>,
        content: [
            {
                title: 'Dashboard',
                menu_key: 'forum_list',
                to: '/forum/dashboard',
            },
            {
                title: 'Forums',
                menu_key: 'forum_list',
                to: '/forum/list',
            },
            {
                title: 'Start Conversation',
                menu_key: 'forum_create',
                to: '/forum/create',
                section: 'forum',
                requiredAction: 'create_edit',
            },
        ],
    },
    {
        title: 'Snap Bill',
        menu_key: 'invoice_scanner',
        classsChange: 'mm-collapse',
        iconStyle: <i className="fas fa-file-invoice"></i>,
        content: [
            {
                title: 'Open Snap Bill',
                menu_key: 'invoice_scanner_access',
                to: '/invoice-scanner/launch',
                feature_key: 'invoice_scanner',
                section: 'invoice_scanner_access',
                requiredAction: 'view',
            },
        ],
    },
    {
        title: 'Documents',
        menu_key: 'documents',
        classsChange: 'mm-collapse',
        iconStyle: <i className="fas fa-file-alt"></i>,
        content: [
            {
                title: 'Dashboard',
                menu_key: 'doc_dashboard',
                to: '/documents/dashboard'
            },
            {
                title: 'My Documents',
                menu_key: 'doc_my_documents',
                to: '/documents/mydocuments'
            },
            {
                title: 'Shared Documents',
                menu_key: 'doc_shared',
                to: '/documents/shared'
            },
            {
                title: 'Favorite Documents',
                menu_key: 'doc_favorites',
                to: '/documents/favorites'
            },
            {
                title: 'Classifications',
                menu_key: 'doc_classifications',
                section: 'doc_classifications',
                requiredAction: 'view',
                to: '/documents/documentClassifications'
            },
        ],
    },
    {
        title: 'Credentials Vault',
        /** When true, keep parent as expand/collapse (show sub-items) instead of merging into one direct link. */
        alwaysShowSubmenu: true,
        classsChange: 'mm-collapse',
        iconStyle: <i className="fas fa-key"></i>,
        content: [
            {
                title: 'Corporate Credentials',
                menu_key: 'credential_vault_list',
                to: '/credential-vault/credentialVaultList',
            },
            {
                title: 'Personal Credentials',
                menu_key: 'credential_vault_list',
                to: '/credential-vault/personalVaultList',
            },
        ],
    },
    {
        title: 'Settings',
        menu_key: 'settings',
        classsChange: 'mm-collapse',
        iconStyle: <i className="fas fa-cog"></i>,
        content: [
            {
                title: 'Users and Roles',
                menu_key: 'settings_users',
                role: 'admin',
                to: 'settings/userlist'
            },
            {
                title: 'flowdo Roles',
                menu_key: 'flowdo_roles',
                role: 'corporate_admin',
                to: 'settings/flowdoRoles'
            },
            {
                title: 'Staff',
                menu_key: 'settings_staff',
                role: 'corporate_admin', // Only corporate admin can access
                to: 'staff/staffList'
            },
            {
                title: 'Access Control',
                menu_key: 'settings_access_control',
                role: 'corporate_admin',
                to: 'settings/accessControl'
            },
            {
                title: 'Branches',
                menu_key: 'settings_branches',
                role: 'corporate_admin', // Only corporate admin can access
                to: 'settings/branchList',
                feature_key: 'branch'
            },
            {
                title: 'Departments',
                menu_key: 'settings_departments',
                role: 'admin', // Corporate and branch admin can access
                restricted_roles: ['department_admin', 'sub_department_admin'], // Department and sub department admin cannot access
                to: 'settings/departmentList',
                feature_key: 'department'
            },
            {
                title: 'Sub Departments',
                menu_key: 'settings_sub_departments',
                role: 'admin', // Corporate, branch, and department admin can access
                restricted_roles: ['sub_department_admin'], // Sub department admin cannot access
                to: 'settings/subDepartmentList',
                feature_key: 'department'
            },
            {
                title: 'Designations',
                menu_key: 'settings_designations',
                role: 'corporate_admin', // Only corporate admin can access
                to: 'settings/designationList',
                feature_key: 'department'
            },
            {
                title: 'Vehicle',
                menu_key: 'settings_vehicle',
                role: 'corporate_admin', // Only corporate admin can access
                to: '/vehicle/vehicleList'
            },
            {
                title: 'Credentials Vault',
                menu_key: 'credential_vault_settings',
                to: '/credential-vault/vaultSettings',
            },
        ],
    },
]